import { CLINICAL_NOTES_MASTER_KEY_LENGTH, PSYCHOLOGIST_ROLE_ID } from '@/config/constants'

export const getDataStoreByKey = (state) => (key) => state[key];

export const getMetricsUUID = (state) => state.metrics.uuid;

export const getToken = (state) => state.auth.token;

export const getRefreshToken = () => null; // Con cookies no se guarda en cliente

export const getLoggedUser = (state) => state.auth.user;

export const getClinicalNotesCryptoStatus = (state) => state.clinicalNotesCryptoStatus;

export const getClinicalNotesMasterKeyBytes = (state) => state.clinicalNotesMasterKeyBytes;

export const getClinicalNotesUnlockDismissed = (state) => state.clinicalNotesUnlockDismissed;

export const getClinicalNotesInteractionsLockedForPsychologist = (state) => {
  const user = state.auth.user;
  if (!user || Number(user.role_id) !== PSYCHOLOGIST_ROLE_ID) return false;

  const status = state.clinicalNotesCryptoStatus;
  if (status == null) return false;
  if (status.pin_configured !== true) return true;

  const masterKeyBytes = state.clinicalNotesMasterKeyBytes;
  return !masterKeyBytes || masterKeyBytes.length !== CLINICAL_NOTES_MASTER_KEY_LENGTH;
}

export const getTokenExpiresIn = (state) => state.auth.tokenExpiresIn;

export const isUserB2B = (state) => state.auth.user ? !!state.auth.user.number_nomina : false;

export const is100User = (state) => state.auth.user ? state.auth.user.is100 : false;

// Con cookies: expiración por timestamp guardado (buffer 10 min)
export const isExpired = (state) => {
  const expiresIn = state.auth.tokenExpiresIn
  if (!expiresIn) return true
  const expirationDate = new Date(expiresIn * 1000)
  const expirationDateWithBuffer = new Date(expirationDate.getTime() - 600000)
  return new Date() > expirationDateWithBuffer
}

export const debugDiffTimeToken = (state) => {
  const expired = state.auth.tokenExpiresIn || 0
  const d1 = new Date(expired * 1000)
  const d2 = new Date()
  return (d1.getTime() - d2.getTime()) / (1000 * 60)
}

// Ya no hay JWT en cliente; compatibilidad devuelve 0 si no hay timestamp
export const getExpires = (state) => state.auth.tokenExpiresIn || 0

export const getRememberUser = (state) => {
  return localStorage.getItem('rememberUser') || ''
}

export const setRememberUser = (rememberUser) => {
  if (rememberUser) {
    localStorage.setItem('rememberUser', rememberUser)
  } else {
    localStorage.removeItem('rememberUser')
  }
}

export const removeRememberUser = () => {
  localStorage.removeItem('rememberUser')
}

export const getIsFamilyRoute = (state) => {
    return state.isFamilyRoute;
}

export const getBrowserTimezone = (state) => {
    let timezone = '';
    switch(state.auth.timezone?.toLowerCase()) {
        case 'etc/gmt+6':
            timezone =  'America/Monterrey';
            break;
        case undefined:
            timezone = 'America/Monterrey';
            break;
        default:
            timezone = state.auth.timezone;
            break;
    }
    return timezone;
}

// Compatibilidad con guard verifyTokenRecoverPassword (recuperación de contraseña)
export const isExpiredPasswordResetToken = () => false